export default __webpack_public_path__ + "static/media/bell.1271774f.svg";